import { ElementRef, inject, input, output, signal, viewChild, } from '@angular/core';
import { DropdownHelperService } from 'Angular/services/dropdown-helper.service';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = ["dropdownMenu"];
const _forTrack0 = ($index, $item) => $item.id;
function AgentTasksComponent_Conditional_0_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg")(3, "defs")(4, "linearGradient", 18);
    i0.ɵɵelement(5, "stop", 19)(6, "stop", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "circle", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("--csRoundedPercentage", ctx_r1.completionPercentage());
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r1.inProgressTasks().length);
} }
function AgentTasksComponent_Conditional_0_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 22);
    i0.ɵɵelementEnd();
} }
function AgentTasksComponent_Conditional_0_Conditional_23_For_1_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const task_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(task_r4.completed_at);
} }
function AgentTasksComponent_Conditional_0_Conditional_23_For_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 23);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Conditional_23_For_1_Template_tr_click_0_listener($event) { const task_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onTaskClicked(task_r4, $event)); });
    i0.ɵɵelementStart(1, "td")(2, "div", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(4, AgentTasksComponent_Conditional_0_Conditional_23_For_1_Conditional_4_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 25)(6, "button", 26);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Conditional_23_For_1_Template_button_click_6_listener($event) { const task_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onHideTask(task_r4, $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 27);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const task_r4 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(task_r4.title);
    i0.ɵɵadvance();
    i0.ɵɵconditional(task_r4.completed_at ? 4 : -1);
} }
function AgentTasksComponent_Conditional_0_Conditional_23_ForEmpty_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 28);
    i0.ɵɵtext(2, "No completed tasks");
    i0.ɵɵelementEnd()();
} }
function AgentTasksComponent_Conditional_0_Conditional_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, AgentTasksComponent_Conditional_0_Conditional_23_For_1_Template, 8, 2, "tr", null, _forTrack0, false, AgentTasksComponent_Conditional_0_Conditional_23_ForEmpty_2_Template, 3, 0, "tr");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.completedTasks());
} }
function AgentTasksComponent_Conditional_0_Conditional_24_For_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 23);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Conditional_24_For_1_Template_tr_click_0_listener($event) { const task_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onTaskClicked(task_r6, $event)); });
    i0.ɵɵelementStart(1, "td", 30)(2, "div", 31)(3, "span", 32);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "td", 25)(6, "button", 26);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Conditional_24_For_1_Template_button_click_6_listener($event) { const task_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onDeleteTask(task_r6, $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 33);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const task_r6 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(task_r6.title);
} }
function AgentTasksComponent_Conditional_0_Conditional_24_For_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 34);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Conditional_24_For_3_Template_tr_click_0_listener($event) { const task_r8 = i0.ɵɵrestoreView(_r7).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onTaskClicked(task_r8, $event)); });
    i0.ɵɵelementStart(1, "td", 30)(2, "div", 35)(3, "span", 32);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "td", 36)(6, "span", 37);
    i0.ɵɵtext(7, "Cancelled");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 26);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Conditional_24_For_3_Template_button_click_8_listener($event) { const task_r8 = i0.ɵɵrestoreView(_r7).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onHideTask(task_r8, $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 27);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const task_r8 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(task_r8.title);
} }
function AgentTasksComponent_Conditional_0_Conditional_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, AgentTasksComponent_Conditional_0_Conditional_24_For_1_Template, 8, 1, "tr", null, _forTrack0);
    i0.ɵɵrepeaterCreate(2, AgentTasksComponent_Conditional_0_Conditional_24_For_3_Template, 10, 1, "tr", 29, _forTrack0);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.inProgressTasks());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.cancelledTasks());
} }
function AgentTasksComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0)(3, "div", 3);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleDropdown()); });
    i0.ɵɵelementStart(4, "div", 4)(5, "span", 5);
    i0.ɵɵtext(6, "Tasks");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(7, AgentTasksComponent_Conditional_0_Conditional_7_Template, 10, 3, "div", 6)(8, AgentTasksComponent_Conditional_0_Conditional_8_Template, 2, 0, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 9)(11, "div", 10)(12, "ul", 11)(13, "li", 12)(14, "a", 13);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Template_a_click_14_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.changeTab("completed", $event)); });
    i0.ɵɵtext(15, "Complete");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "li", 12)(17, "a", 13);
    i0.ɵɵlistener("click", function AgentTasksComponent_Conditional_0_Template_a_click_17_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.changeTab("in-progress", $event)); });
    i0.ɵɵtext(18, "In Progress");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(19, "div", 14)(20, "div", 15)(21, "table", 16)(22, "tbody");
    i0.ɵɵconditionalCreate(23, AgentTasksComponent_Conditional_0_Conditional_23_Template, 3, 1)(24, AgentTasksComponent_Conditional_0_Conditional_24_Template, 4, 0);
    i0.ɵɵelementEnd()()()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("show", ctx_r1.isDropdownOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("active", ctx_r1.isDropdownOpen());
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.hasInProgressTasks() ? 7 : 8);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("show", ctx_r1.isDropdownOpen());
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("active", ctx_r1.chosenTab() === "completed");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("active", ctx_r1.chosenTab() === "in-progress");
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r1.chosenTab() === "completed" ? 23 : 24);
} }
export class AgentTasksComponent {
    constructor() {
        this._dropdownHelperService = inject(DropdownHelperService);
        this.visibleTasks = input.required(...(ngDevMode ? [{ debugName: "visibleTasks" }] : []));
        this.completedTasks = input.required(...(ngDevMode ? [{ debugName: "completedTasks" }] : []));
        this.inProgressTasks = input.required(...(ngDevMode ? [{ debugName: "inProgressTasks" }] : []));
        this.cancelledTasks = input.required(...(ngDevMode ? [{ debugName: "cancelledTasks" }] : []));
        this.hasInProgressTasks = input.required(...(ngDevMode ? [{ debugName: "hasInProgressTasks" }] : []));
        this.completionPercentage = input.required(...(ngDevMode ? [{ debugName: "completionPercentage" }] : []));
        this.taskSelected = output();
        this.deleteTask = output();
        this.hideTask = output();
        this.isDropdownOpen = signal(false, ...(ngDevMode ? [{ debugName: "isDropdownOpen" }] : []));
        this.chosenTab = signal('in-progress', ...(ngDevMode ? [{ debugName: "chosenTab" }] : []));
        this.dropdownMenu = viewChild('dropdownMenu', ...(ngDevMode ? [{ debugName: "dropdownMenu" }] : []));
    }
    ngAfterViewInit() {
        const dropdown = this.dropdownMenu();
        if (dropdown) {
            this._dropdownHelperService.setCloseHandler(dropdown.nativeElement, () => {
                if (this.isDropdownOpen()) {
                    this.isDropdownOpen.set(false);
                }
            });
        }
    }
    toggleDropdown() {
        this.isDropdownOpen.update((x) => !x);
    }
    changeTab(tab, event) {
        event.preventDefault();
        event.stopPropagation();
        this.chosenTab.set(tab);
    }
    onTaskClicked(task, event) {
        event.stopPropagation();
        this.taskSelected.emit(task);
    }
    onDeleteTask(task, event) {
        event.stopPropagation();
        this.deleteTask.emit(task);
    }
    onHideTask(task, event) {
        event.stopPropagation();
        this.hideTask.emit(task);
    }
}
AgentTasksComponent.ɵfac = function AgentTasksComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentTasksComponent)(); };
AgentTasksComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentTasksComponent, selectors: [["ycn-agent-tasks"]], viewQuery: function AgentTasksComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.dropdownMenu, _c0, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, inputs: { visibleTasks: [1, "visibleTasks"], completedTasks: [1, "completedTasks"], inProgressTasks: [1, "inProgressTasks"], cancelledTasks: [1, "cancelledTasks"], hasInProgressTasks: [1, "hasInProgressTasks"], completionPercentage: [1, "completionPercentage"] }, outputs: { taskSelected: "taskSelected", deleteTask: "deleteTask", hideTask: "hideTask" }, decls: 1, vars: 1, consts: [["dropdownMenu", ""], [1, "side-panel-tasks-bar"], [1, "dropdown"], [1, "dropdown-toggle", "height-40", "pl-20", "pr-20", 3, "click"], [1, "d-flex", "align-items-center", "mr-2"], [1, "text-thin"], [1, "d-flex", "align-items-center", "ml-1"], [1, "d-flex", "align-items-center", "justify-content-center", "ml-1", "border-2", "border-color-green", "width-24", "height-24", "rounded-full", "text-green"], [1, "collapse-chevron", "align-self-center"], [1, "dropdown-menu", "dropdown-menu-fullwidth", "pt-0"], [1, "panel-action", "min-height-base", "pt-0", "pb-0"], [1, "nav", "nav-tabs", "justify-content-start"], [1, "nav-item"], ["href", "#", 1, "nav-link", "text-normal-case", 3, "click"], [1, "tab-content"], [1, "tab-pane", "pl-0", "pr-0", "active"], [1, "table", "table-hover", "mb-0"], [1, "circle-stats-rounded", "ml-1", 2, "--cs-rounded-size", "26px", "--cs-rounded-stroke-width", "3px"], ["id", "circleGradientTasks", "x1", "0%", "y1", "0%", "x2", "100%", "y2", "100%"], ["offset", "0%", "stop-color", "#0273CF"], ["offset", "100%", "stop-color", "#E5F2FC"], ["cx", "13", "cy", "13", "r", "11.5", 1, "progress", 2, "stroke", "url(#circleGradientTasks)"], ["ycnIcon", "", "name", "icon-check", 1, "fill-current", "text-smallest"], [3, "click"], [1, "text-default"], [1, "pl-0", "text-right"], [1, "btn", "btn-transparent", "btn-lightgray", "btn-circle", "btn-xs", 3, "click"], ["ycnIcon", "", "name", "icon-close"], [1, "text-center", "text-gray-30"], [1, "disabled"], [1, "max-width-150"], [1, "td-ellipsis", "text-blue"], [1, "td-ellipsis-content"], ["ycnIcon", "", "name", "icon-delete"], [1, "disabled", 3, "click"], [1, "td-ellipsis"], ["colspan", "2", 1, "text-right"], [1, "mr-1"]], template: function AgentTasksComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, AgentTasksComponent_Conditional_0_Template, 25, 12, "div", 1);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.visibleTasks().length ? 0 : -1);
    } }, dependencies: [IconModule, i1.IconDirective], encapsulation: 2, changeDetection: 0 });
